import { Box } from '@chakra-ui/react';

import { GradientEmptyPage } from './GradientEmptyPage';
import { MockCreatorEmptyResults } from './mockCreatorEmptyResults';

export const InviteCreatorEmptyMockResults: React.FC = () => {
  return (
    <Box style={{ pointerEvents: 'none' }}>
      <MockCreatorEmptyResults />
      <GradientEmptyPage
        infoText="Start by adding talent to build your first pitch list, rosters,
            media packs, and gain access to live content and social analytics."
      />
    </Box>
  );
};
